import { Options } from '@utils/index'

const status = new Options('barcode.rule')
  .add(1, 'statusOptions[0]')
  .add(0, 'statusOptions[1]')

const barType = new Options('barcode.rule')
  .add('', 'barTypeOptions[0]')
  .add('2', 'barTypeOptions[1]')

const fieldType = new Options('barcode.rule')
  .add('yyyyMMdd', 'fieldTypeOptions[0]')
  .add('yyMMdd', 'fieldTypeOptions[1]')
  .add('yyyyMM', 'fieldTypeOptions[2]')
  .add('yyMM', 'fieldTypeOptions[3]')
  .add('MMddyyyy', 'fieldTypeOptions[4]')
  .add('MMddyy', 'fieldTypeOptions[5]')
  .add('MMdd', 'fieldTypeOptions[6]')
  .add('yyyy', 'fieldTypeOptions[7]')
  .add('yy', 'fieldTypeOptions[8]')

export {
  status,
  barType,
  fieldType
}
